import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { RensComplementaires } from '../models/RensComplementaires';
@Component({
  selector: 'app-rens-complementaires',
  templateUrl: './rens-complementaires.component.html'
})
export class RensComplementairesComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'RensComplementaires';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() rensComplementaires: RensComplementaires;

  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {}
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

